export const SCROLL_DIRECTION = {
    TO_BOTTOM: 'toBottom',
    TO_TOP: 'toTop'
};
